import { render, staticRenderFns } from "./RedefinePassword.vue?vue&type=template&id=2a634ff3&scoped=true"
import script from "./RedefinePassword.vue?vue&type=script&lang=js"
export * from "./RedefinePassword.vue?vue&type=script&lang=js"
import style0 from "./RedefinePassword.vue?vue&type=style&index=0&id=2a634ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a634ff3",
  null
  
)

export default component.exports